/* eslint-disable no-undef */
import { RouteComponentProps } from "@reach/router";
import * as React from "react";
import { Grid } from "@mui/material";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import SettingsContent from "../../components/Settings/SettingsContent";
import { GetOrganizationBasics_organization } from "../../components/GetStarted/__generated__/GetOrganizationBasics";

interface Props extends RouteComponentProps {
    organizationId?: string;
    organization: GetOrganizationBasics_organization;
}

// eslint-disable-next-line no-empty-pattern
export default function Settings({ organizationId, organization }: Props) {
    return (
        <Grid container spacing={{ xs: 5, md: 6 }}>
            <Grid item xs={12}>
                <SectionTitle title={`Settings`} align={"left"} showBottomBorder />
                <SettingsContent organization={organization} />
            </Grid>
        </Grid>
    );
}
